import { DataTableBodyCellDate, TableCellRowLine } from '@/components/custom';
import DataTableBodyCellPermissions from './DataTableBodyCellPermissions';
import FormEditOrAssignPermissions from '../formEditOrAssignPermissions';
import DataTableBodyCellOptions from './DataTableBodyCellOptions';
import { TableBody, TableCell, TableRow } from '@/components/ui';
import { broadcastService } from '@/services';
import { useEmployees } from '../../hooks';
import { IEmployee } from '@/interfaces';
import dayjs from 'dayjs';

export const DataTableBody = () => {

  const { employees } = useEmployees();

  const onSelectEmployee = (employee: IEmployee) => {
    broadcastService
      .modal
      .show({
        content: <FormEditOrAssignPermissions employee={employee} />,
        fullScreenOnMobile: true,
        showCloseIcon: true,
        width: 'lg'
      });
  };

  return (
    <TableBody>
      {
        [...employees]
          .sort((a, b) => dayjs(b.createdAt) > dayjs(a.createdAt) ? 1 : -1)
          .map(
            (l, index) => (
              <TableRow
                key={l._id}
                onClick={() => onSelectEmployee(l)}
                className='cursor-pointer'>
                <TableCellRowLine value={index + 1} />
                <TableCell className='py-1 pe-0 w-28'>
                  {l.username}
                </TableCell>
                <TableCell className='py-1 pe-0 w-0 text-muted-foreground'>
                  {l.email}
                </TableCell>
                <DataTableBodyCellPermissions employee={l} />
                <DataTableBodyCellDate date={l.createdAt} />
                <DataTableBodyCellOptions {...l} />
              </TableRow>
            )
          )
      }
    </TableBody>
  );

};

export default DataTableBody;
